/* eslint-disable no-secrets/no-secrets */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TwiaPolicyService {

    static getAccountPolicySummaries(additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiapolicy'), 'getAccountPolicySummaries', [], additionalHeaders);
    }

    static getAccountPolicyOffers(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('twiapolicy'), 'getAccountPolicyOffers', [], additionalHeaders);
    }

    static removeDocument(publicID, additionalHeaders = {}){
        return JsonRPCService.send('pc', 'policy/docs', 'removeDocument', [publicID], additionalHeaders);
    }

    static getPolicyDocumentsForRoles_TWIA(policyNumber, recipientRoles, additionalHeaders= {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiadocs'), 'getPolicyDocumentsForRoles_TWIA', [policyNumber, recipientRoles], additionalHeaders);
    }

    static getJobDocumentsForRoles_TWIA(jobNumber, recipientRoles, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiadocs'), 'getJobDocumentsForRoles_TWIA', [jobNumber, recipientRoles], additionalHeaders);
    }

    static getAccountPolicyDetails(policyNumber, additionalHeaders = {}){
        return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicyDetails', [policyNumber], additionalHeaders);
    }

    static getAccountOfferDetails(offerNumber, additionalHeaders = {}){
        return JsonRPCService.send('pc', 'policy/policy', 'getAccountOfferDetails', [offerNumber], additionalHeaders);
    }

    static retrieveInstallmentsPreview(offerNumber, planID, additionalHeaders = {}){
        return JsonRPCService.send(getProxiedServiceUrl('twiapolicy'), 'retrieveInstallmentsPreview', [offerNumber, planID], additionalHeaders);
    }

    static getAccountPolicySummaries_TWIA(summaryType, additionalHeaders = {}) {
        return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicySummaries_TWIA', [summaryType], additionalHeaders);
    }

    static customerPayAndBind_TWIA(offerNumber, bindData, overrideDupPayment, additionalHeaders = {})  {
        return JsonRPCService.send('pc', 'policy/policy', 'customerPayAndBind_TWIA', [offerNumber, bindData, overrideDupPayment], additionalHeaders);
    }

    static updatePrivacyPolicy(policyNumber, decision, additionalHeaders = {}) {
        return JsonRPCService.send('pc', 'policy/policy', 'updatePolicyPrivacyOptOut', [policyNumber, decision], additionalHeaders)
    }



}
